import { FUNNEL, TABLE } from 'reporting-data/constants/chartTypes';
import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { isConfigReport, isCustomWidgetReport, isJourneyReport, isMultiConfigReport, isRelationalReport, isUnifiedAnalyticsReport } from 'reporting-data/tsTypes/reportTypes';
import { getReportDatasetFromReportResolve } from 'reporting-data/report/reportResolveUtils';
import { Dataset } from 'reporting-data/v2/dataset/datasetTypes';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
// @ts-expect-error Untyped import
import { isOnlySupportedViaBackendResolve } from 'reporting-data/v2/reportingApi/isSupportedForBackendResolve';
import { AI_INSIGHTS_UPDATE_GATE, JOURNEY_AI_INSIGHTS_GATE, REPORTING_AI_INSIGHTS_SLIDER_GATE, TABLE_REPORT_INSIGHTS_GATE } from '../../../../constants/gates';
import { REPORT_INSIGHTS_ACCESS_SCOPE } from '../../../../constants/scopes';
import { isJourneyDrilldownReport } from 'reporting-snowflake/funnel/types/journeyReport';
import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
export const USER_FEEDBACK_URL = 'reporting-insights/copilot/v1/generate/feedback';
export const REPORTING_USER_FEEDBACK_URL = 'reporting-insights/copilot/v1/generate/insights-feedback';
export const FEEDBACK_TYPE = {
  VERIFICATION: 'VERIFICATION',
  INSIGHTS: 'INSIGHTS'
};
export const getDatasetFromReportResolve = (report, reportResolve) => {
  let dataset;
  if (!reportResolve || !reportResolve.data) {
    return dataset;
  } else if (isRelationalReport(report)) {
    dataset = reportResolve;
  } else if (isJourneyReport(report)) {
    dataset = Dataset(reportResolve.getIn(['resolveDatamap', 'primary']));
  } else {
    dataset = reportResolve.data.getIn(['primary', 'data']);
  }
  return dataset;
};
export const getIsInsightsShown = (report, userInfo) => {
  const {
    gates,
    user: {
      scopes
    }
  } = userInfo;
  const isUngatedForInsights = (gates === null || gates === void 0 ? void 0 : gates.includes(REPORTING_AI_INSIGHTS_SLIDER_GATE)) || (gates === null || gates === void 0 ? void 0 : gates.includes(AI_INSIGHTS_UPDATE_GATE));
  const isSearchReportAndIsUngatedForSearchInsights = isConfigReport(report) && isSearchReport(report) && (gates === null || gates === void 0 ? void 0 : gates.includes(TABLE_REPORT_INSIGHTS_GATE));
  const hasReportingInsightsAccessScope = scopes.includes(REPORT_INSIGHTS_ACCESS_SCOPE);
  if (!isUngatedForInsights || !hasReportingInsightsAccessScope) {
    return false;
  }
  if (isJourneyReport(report)) {
    return (gates === null || gates === void 0 ? void 0 : gates.includes(JOURNEY_AI_INSIGHTS_GATE)) && !isJourneyDrilldownReport(report.toJS());
  }
  const isExternalDataSourceFunnelReport = isConfigReport(report) && getStandardFieldType(report, STANDARD_FIELD_TYPES.DATA_TYPE) === 'EXT_SMS_ANALYZE_FUNNEL_CHART';
  if (isConfigReport(report) && !!report.getIn(['config', 'compare']) || isConfigReport(report) && !isOnlySupportedViaBackendResolve(report) && !isUnifiedAnalyticsReport(report) || isExternalDataSourceFunnelReport || isMultiConfigReport(report) || isCustomWidgetReport(report) || isConfigReport(report) && [FUNNEL, TABLE].includes(report.get('chartType')) && !isSearchReportAndIsUngatedForSearchInsights || isRelationalReport(report) && [VisualTypes.TABLE, VisualTypes.PIVOT_TABLE].includes(report.getIn(['reportDefinition', 'visual', 'type']))) {
    return false;
  }
  if (isConfigReport(report) && isSearchReport(report)) {
    return gates === null || gates === void 0 ? void 0 : gates.includes(TABLE_REPORT_INSIGHTS_GATE);
  }
  return true;
};
export const getReportDatasetHasNotEnoughDataForAIInsights = (report, reportResolve) => {
  var _reportDataset$get;
  const reportDataset = getReportDatasetFromReportResolve(report, reportResolve);
  return !(reportDataset !== null && reportDataset !== void 0 && (_reportDataset$get = reportDataset.get) !== null && _reportDataset$get !== void 0 && (_reportDataset$get = _reportDataset$get.call(reportDataset, 'data')) !== null && _reportDataset$get !== void 0 && _reportDataset$get.length) || reportDataset.get('data').length <= 2;
};